import { useState,useEffect, useRef } from "react";
import { getFromlocalstorage } from "../../../../../component/MaHoaDuLieu";
import { useUser } from "../../../../../component/UserProvider/UserProvider";
import Notify from "../../../../../component/Notify/Notify";
import Loading from "../../../../../component/Loading/Loading";

function MangLuoi () {
  const [loading, setLoading] = useState(false)
  const [phoneNumber, setPhoneNumber] = useState('')
  const [Message, setMessage] = useState('')
  const [typenoti, settypenoti] = useState('error')
  const apiUrl = process.env.REACT_APP_API_BACKEND;
  const data = JSON.parse(getFromlocalstorage("data_u"));
    const hasFetched = useRef(false);
  
    const { user, fetchUser } = useUser();
    useEffect(() => {
        if (data && !hasFetched.current) {
          fetchUser(data._id);
          hasFetched.current = true;
        }
      }, [data]);
      useEffect(() => {
    if (user && user.crypto_wallet) {
      setPhoneNumber(user.crypto_wallet) 
    }
  }, [user])

  const handleUpdateWallet = async () => {
    setLoading(true)
    try {
      const response = await fetch(
        `${apiUrl}/postcryto_wallet/${user._id}`, 
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ cryto_wallet: phoneNumber }) 
        }
      )

      const data = await response.json()

      if (!response.ok) {
        throw new Error(data.message)
      }

      setMessage("อัปเดตสำเร็จ")
      settypenoti('success')
     
    } catch (error) {
      setMessage(error.message || 'เกิดข้อผิดพลาดที่เซิร์ฟเวอร์ กรุณาลองใหม่อีกครั้ง')
      settypenoti('error')
    } finally {
      setLoading(false)
    }
  }
  return (
    <div className='withdraw_nganhang'>
      <div className='withdraw_nganhang_littel'></div>

      <div className='withdraw_nganhang_input_tong width_pass border_bottom'>
        <div className='withdraw_nganhang_title_input'>เครือข่าย</div>
        <div className='withdraw_nganhang_input'>TRC20</div>
      </div>

      <div className='withdraw_nganhang_input_tong width_pass border_bottom'>
        <div className='withdraw_nganhang_title_input'>ที่อยู่กระเป๋าเงิน</div>
        <div className='withdraw_nganhang_input'>
           <input
                type='text'
                id='phone-number'
                placeholder={"กรอกที่อยู่กระเป๋าเงิน"}
                required
                value={phoneNumber}
                onChange={e => setPhoneNumber(e.target.value)}
              />
        </div>
      </div>
      <div className='withdraw_nganhang_submit_btn'>
        <button className='withdraw_nganhang_submit_btn_btngui' onClick={handleUpdateWallet}>เชื่อมโยง</button>
        <button className='withdraw_nganhang_submit_btn_btncailai'>
            รีเซ็ต
        </button>
      </div>
      {Message && (
        <Notify message={Message} type={typenoti} setcontent={setMessage} />
      )}
      <Loading isLoading={loading} />
    </div>
  )
}

export default MangLuoi
